import React from "react";
import Footer from "../../Share/Footer/Footer";
import Header from "../../Share/Header/Header";

const Dealers = () => {
    return (
        <div>
            <Header></Header>
            <div className="container py-5">
                <h2>All Dealer Information</h2>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Dealers;
